export default function Loading() {
	return <div className="loader-background">
		<div className="loader-fill"/>
		<div className="loader"/>
	</div>
}

